import HelperString from 'utils/helper-string'
import { StyleSheet, View } from 'react-native'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { colorList } from 'utils/colors'
import Text from "theme/Text";
import { textStyles } from 'styles/text'
import Translate from 'utils/translate'
import React from 'react'
import { ThemedValues } from 'styles/themed'

const PresenceMessageView = ({ message, timeslotGroup, timeslotKind }) => {
	
	
	const timeslotGroupTitle = Translate.field( timeslotGroup, 'title' )
	const timeslotKindTitle = Translate.field( timeslotKind, 'title' )
	
	return (
		<View
			key={ HelperString.hash('transport', 'message' ) }
			style={ styles.messageContainer }>
			
			<View
				style={styles.viewFlexDirectionColumn}>
				
				<View
					style={styles.viewFlexDirectionRow}>
					
					<View
						style={ styles.messageIcon }>
						
						<Icon
							icon={ IconSystemConstants.SUCCESS }
							animation={ "pulse" }
							size={ 28 }
							color={ colorList.GREEN.primary }
						/>
					</View>
					
					<Text
						category={"h5"}
						style={ textStyles.textCenter }>
						
						{ message }
					</Text>
				</View>
				
				{ timeslotGroupTitle !== null && (
					<Text
						style={styles.textTextAlignCenter}>
						
						{ timeslotGroupTitle }
					</Text>
				)}
				
				{ timeslotKindTitle !== null && timeslotKindTitle !== timeslotGroupTitle && (
					<Text
						style={styles.textTextAlignCenter}>
						
						{ timeslotKindTitle }
					</Text>
				)}
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	viewFlexDirectionColumn: {
		flexDirection: 'column',
	},
	viewFlexDirectionRow: {
		flexDirection: 'row',
	},
	textTextAlignCenter: {
		textAlign: 'center',
	},
	messageContainer: {
		width: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: ThemedValues.marginHorizontal
	},
	messageIcon: {
		justifyContent: 'center',
		alignItems: 'flex-end',
	},
})

export default PresenceMessageView;
